import React from 'react';
import { Box, Typography } from '@mui/material';
import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');

function DesligamentoModelo({
  data = moment(new Date()).format('DD [de] MMMM [de] YYYY'),
  sociedade = '',
  nomeAssinatura = '',
  documentoAssinatura = '',
  exibeCategoriaAutor = false,
  exibeCategoriaEditor = false,
  exibeCategoriaInterprete = false,
  exibeCategoriaMusico = false,
  exibeCategoriaProdutor = false,
}) {
  return (
    <Box
      sx={{
        maxWidth: 600,
        margin: '0 auto',
        padding: 4,
        fontFamily: 'Arial, sans-serif',
        lineHeight: '1.5',
        color: '#000',
        backgroundColor: 'white',
        borderRadius: '5px'
      }}
    >
      {/* LOGO */}
      <Box sx={{ textAlign: 'left', mb: 2 }}>
        <img
          src="logo.png"
          alt="Logo UBC"
          style={{ height: 50 }}
        />
      </Box>

      {/* TÍTULO */}
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          DESLIGAMENTO
        </Typography>
      </Box>

      {/* DATA */}
      <Box sx={{ mb: 1 }}>
        <Typography>Rio de Janeiro, {data}</Typography>
      </Box>

      {/* ENDEREÇAMENTO */}
      <Box sx={{ mb: 3 }}>
        <Typography>À {sociedade}</Typography>
      </Box>

      {/* CORPO DO TEXTO */}
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ textAlign: 'justify' }}>
          Venho pelo presente, em consonância ao art. 97, §2°, da lei nº 9.610/98,
          comunicar a V.Sas. o meu desligamento do Quadro Social desta sociedade,
          na(s) categoria(s):
        </Typography>
      </Box>

      {/* DIREITOS AUTORAIS */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2 }}>
          Direitos Autorais
        </Typography>
        <Typography>
          ( {exibeCategoriaAutor ? 'X' : ' '} ) Autor/Compositor &nbsp;&nbsp;
          ( {exibeCategoriaEditor ? 'X' : ' '} ) Editor
        </Typography>
      </Box>

      {/* DIREITOS CONEXOS */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 2 }}>
          Direitos Conexos
        </Typography>
        <Typography>
          ( {exibeCategoriaInterprete ? 'X' : ' '} ) Intérprete &nbsp;&nbsp;
          ( {exibeCategoriaMusico ? 'X' : ' '} ) Musico &nbsp;&nbsp;
          ( {exibeCategoriaProdutor ? 'X' : ' '} ) Produtor Fonográfico
        </Typography>
      </Box>

      {/* FECHAMENTO */}
      <Box sx={{ mb: 3 }}>
        <Typography>na data de hoje.</Typography>
        <Typography>Sem mais,</Typography>
      </Box>

      {/* ASSINATURA */}
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Box
          sx={{
            width: '100%',
            margin: '20px auto',
            borderBottom: '1px solid #000',
            maxWidth: 300,
          }}
        />
        <Typography>Assinatura</Typography>
        <Typography>
          {documentoAssinatura && ` ${documentoAssinatura}`}
        </Typography>
        <Typography>
          {nomeAssinatura.toUpperCase()}
        </Typography>
      </Box>

      {/* C.C. */}
      <Box>
        <Typography>C.c. ECAD</Typography>
      </Box>
    </Box>
  );
}

export default DesligamentoModelo;
